import { render, staticRenderFns } from "./CreateContainerOrdersDialog.vue?vue&type=template&id=5dc384bf"
import script from "./CreateContainerOrdersDialog.vue?vue&type=script&lang=js"
export * from "./CreateContainerOrdersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports